var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutzerAngemeldet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Nutzer-Angemeldet__Icn/40px/Nutzer-Angemeldet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Nutzer-Angemeldet__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Nutzer-Angemeldet__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2710465,21.1195621 L35.0622808,22.0092136 L28.9145727,34.3870767 C28.6515053,34.9167396 27.9964289,35.0963235 27.5047693,34.8001374 L27.4021174,34.7293409 L21.1643364,29.8408252 L22.3980128,28.2666453 L27.6684584,32.3973217 L33.2710465,21.1195621 Z M20,18 C23.7311957,18 26.7805601,20.9192669 26.9886714,24.5983789 L26.1088042,26.3672737 L25,25.541 L25,25 C25,22.3112453 22.8776933,20.1181819 20.2168896,20.0046195 L20,20 L17,20 C14.3112453,20 12.1181819,22.1223067 12.0046195,24.7831104 L12,25 L12,27 L17.863,27 L16.766,29 L10,29 L10,25 C10,21.1340068 13.1340068,18 17,18 L20,18 Z M18.5,7 C21.2614237,7 23.5,9.23857625 23.5,12 C23.5,14.7614237 21.2614237,17 18.5,17 C15.7385763,17 13.5,14.7614237 13.5,12 C13.5,9.23857625 15.7385763,7 18.5,7 Z M18.5,9 C16.8431458,9 15.5,10.3431458 15.5,12 C15.5,13.6568542 16.8431458,15 18.5,15 C20.1568542,15 21.5,13.6568542 21.5,12 C21.5,10.3431458 20.1568542,9 18.5,9 Z",
    id: ".._.._src_svg_Icn_40px_Nutzer-Angemeldet__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutzerAngemeldet);
export default __webpack_public_path__ + "static/media/Nutzer-Angemeldet.b7945d9b2d7092bdd01586d7be1de3b8.svg";
export { ForwardRef as ReactComponent };